import { gql, useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import NameTableTranslatable from "./nameTableTranslateable";
import TranslationWrapper from "./translationWrapper";


import { getQueryVariables } from "../../utils";
import { GraphQLPagination } from "../common";
import TagsTranslationForm from "./tagsTranslationForm";

const GET_TAGS = gql`query MyQuery {
  producttags(first: 10, last: 10, before: "", after: "") {
    edges {
      cursor
      node {
        dbId
        name
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}`

function TagsTranslation() {
  const { languageCode } = useParams<{ languageCode: string }>();
  const [tagId, setTagId] = useState<number | null>(null);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  const { data, loading, error } = useQuery(GET_TAGS, {
    variables: getQueryVariables(searchParams),
    notifyOnNetworkStatusChange: true,
  });

  const handleOpenForm = (id: number) => {
    setIsFormOpen(true);
    setTagId(id);
  };


  const handleCloseForm = () => setIsFormOpen(false);

  useEffect(() => {
    if (!searchParams.get("first") && !searchParams.get("last")) {
      setSearchParams({ first: "20" });
    }
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;

  const tags = data?.producttags?.edges || [];

  return (
    <TranslationWrapper>
      <>
        <NameTableTranslatable data={tags} onOpenForm={handleOpenForm} />

        <GraphQLPagination
          edges={data?.producttags?.edges || []}
          pageInfo={data?.producttags?.pageInfo || {}}
        />
        {isFormOpen && (
          <TagsTranslationForm
            id={tagId}
            isOpen={isFormOpen}
            onClose={handleCloseForm}
          />
        )}
      </>
    </TranslationWrapper>
  );
}

export default TagsTranslation;